// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module--footer--2j8xa"};